import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import List from '@material-ui/core/List';
import { mainList, configurationList, noteList, accountList } from './listItems';


import styles from './styles';

class LeftDrawer extends React.Component {


  render() {

    const { classes, open, toggleDrawer } = this.props;
    return (
      <Drawer
        variant="permanent"
        classes={{
          paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton color="inherit" onClick={toggleDrawer}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>{mainList}</List>
        <Divider />
        <List>{configurationList}</List>
        <Divider />
        <List>{noteList}</List>
        <Divider />
        <List>{accountList}</List>
      </Drawer>
    );

  }
}


LeftDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDrawer: PropTypes.func,
};

export default withStyles(styles)(LeftDrawer);



// WEBPACK FOOTER //
// ./src/components/dashboard/LeftDrawer.js